import type { SetActivitySummaryStatsAction } from './typings'
import type { ActivitySummaryTopStatsDTO } from '../../../typings'

export const setActivitySummaryStatsActionCreator = (
  payload: ActivitySummaryTopStatsDTO,
): SetActivitySummaryStatsAction => ({
  type: 'activitySummary/setStats',
  payload,
})
